(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const decodePhone = (encoded, shift) => {
    if (encoded === null || typeof encoded === 'undefined' || encoded === '') {
      return encoded;
    }

    const parsedShift = parseInt(shift, 10);
    if (Number.isNaN(parsedShift)) {
      return encoded;
    }

    const normalizedShift = ((parsedShift % 10) + 10) % 10;

    return `${encoded}`.replace(/\d/g, (digit) => {
      const decodedDigit = (parseInt(digit, 10) - normalizedShift + 10) % 10;
      return `${decodedDigit}`;
    });
  };

  const toTelDigits = (phoneNumber = '') => `${phoneNumber}`.replace(/\D/g, '');

  global.NewHomeSource.PhoneCipher = Object.assign({}, global.NewHomeSource.PhoneCipher, {
    decodePhone,
    toTelDigits,
  });
}(window));
